import React from "react";
import { Field, useFormikContext } from "formik";

import { DialogContent, TextField } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import TabPanel from "../TabPanel";

/**
 * Tab "NPS" — mensagem de avaliação e configurações de NPS.
 * Compartilhada entre WhatsAppModal (nativo) e PluginConnectionModal.
 * Lê dados do Formik via useFormikContext — deve renderizar dentro de <Formik>.
 */
const NpsTab = ({ tab, classes }) => {
  const { touched, errors } = useFormikContext();

  return (
    <TabPanel className={classes.container} value={tab} name="nps">
      <DialogContent dividers>
        {/* MENSAGEM DE AVALIAÇAO*/}
        <div>
          <Field
            as={TextField}
            label={i18n.t("whatsappModal.form.ratingMessage")}
            multiline
            rows={4}
            fullWidth
            name="ratingMessage"
            error={touched.ratingMessage && Boolean(errors.ratingMessage)}
            helperText={touched.ratingMessage && errors.ratingMessage}
            variant="outlined"
            margin="dense"
          />
        </div>
        {/* QUANTIDADE MÁXIMA DE VEZES QUE O NPS VAI SER ENVIADO */}
        <div>
          <Field
            as={TextField}
            label={i18n.t("whatsappModal.form.maxUseBotQueuesNPS")}
            fullWidth
            name="maxUseBotQueuesNPS"
            variant="outlined"
            margin="dense"
            error={
              touched.maxUseBotQueuesNPS &&
              Boolean(errors.maxUseBotQueuesNPS)
            }
            helperText={
              touched.maxUseBotQueuesNPS && errors.maxUseBotQueuesNPS
            }
          />
        </div>
        {/* ENCERRAR CHATS NPS APÓS X Minutos */}
        <div>
          <Field
            as={TextField}
            label={i18n.t("whatsappModal.form.expiresTicketNPS")}
            fullWidth
            name="expiresTicketNPS"
            variant="outlined"
            margin="dense"
            error={
              touched.expiresTicketNPS &&
              Boolean(errors.expiresTicketNPS)
            }
            helperText={touched.expiresTicketNPS && errors.expiresTicketNPS}
          />
        </div>
      </DialogContent>
    </TabPanel>
  );
};

export default NpsTab;
